import { type KeyboardEventHandler, useEffect, useState } from 'react'

export function PopoutInput(props: { initialValue: string | undefined; updateValue: (value: string | undefined) => void; editable: boolean }) {
  const [isFocused, setIsFocused] = useState<boolean>(false)
  const [value, setValue] = useState<string>(props.initialValue ?? '')

  const handleKey: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === 'Enter') {
      if (value != props.initialValue) {
        props.updateValue(value)
      }
      setIsFocused(false)
    }
  }

  useEffect(() => {
    setValue(props.initialValue ?? '')
  }, [isFocused, props.initialValue])

  if (!isFocused)
    return (
      <input
        type="text"
        className={`input input-sm input-bordered rounded-sm w-full`}
        value={props.initialValue}
        onFocus={() => setIsFocused(true)}
        disabled={!props.editable}
        readOnly={true}
      />
    )

  return (
    <div id="popout" className="relative left-0 w-96 shadow-lg bg-white flex flex-col">
      Edit Value, press Enter to submit
      <input
        type="text"
        value={value}
        onChange={(e) => setValue((e.target as HTMLInputElement).value)}
        autoFocus={true}
        onBlur={() => setIsFocused(false)}
        onKeyDown={(e) => handleKey(e)}
      />
    </div>
  )
}
